import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ContentService } from '@services/content.service';
import { HelperService } from '@services/helper.service';

@Component({
  selector: 'app-book-demo-button',
  templateUrl: './book-demo-button.component.html',
})
export class BookDemoButtonComponent {
  private helperService = inject(HelperService);
  private contentService = inject(ContentService);

  buttonText = '';

  constructor() {
    this.contentService.bookDemoSectionDataLoaded
      .pipe(takeUntilDestroyed())
      .subscribe(
        data => this.buttonText = `${data.metaData.service ?? 'Beratungsgespräch'} buchen`
      );
  }

  onClick() {
    this.helperService.scrollToSection('demo');
  }
}
